export interface MonitoringFormErrors {
  userEmail?: string;
  parameterEmail?: string;
  preferredTime?: string;
  preferredDay?: string;
  preferredDate?: string;
}

export const validateMonitoringForm = (values: {
  userEmail: string;
  parameterEmail: string;
  frequency: string;
  preferredTime?: string;
  preferredDay?: number;
  preferredDate?: number;
}): MonitoringFormErrors => {
  const errors: MonitoringFormErrors = {};

  if (!values.userEmail) {
    errors.userEmail = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(values.userEmail)) {
    errors.userEmail = "Invalid email address";
  }

  if (!values.parameterEmail) {
    errors.parameterEmail = "Domain is required";
  } else if (
    !/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/.test(
      values.parameterEmail
    )
  ) {
    errors.parameterEmail = "Invalid domain format";
  }

  if (!values.preferredTime) {
    errors.preferredTime = "Preferred time is required";
  }

  return errors;
};
